<!-- Page Header Start-->
<div class="header-wrapper">
  <div class="page-header" [class.close_icon]="navServices.collapseSidebar">
    <div class="header-wrapper row m-0">
      <app-search></app-search>
      <div class="col-2 header-logo-wrapper">
        <div class="logo-wrapper">
          <a routerLink="/">
            <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
            <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="" />
          </a>
        </div>
        <div class="toggle-sidebar" (click)="sidebarToggle()">
          <app-feather-icons [icon]="'align-center'" class="status_toggle middle"></app-feather-icons>
        </div>
      </div>
      <div class="nav-right col-10 pull-right right-header p-0">
        <ul class="nav-menus">

          <ng-container *ngIf="isBetaTesterOrDesktop()">
            <button class="btn btn-outline-primary w-100 me-2" routerLink="/buy"> KUPI</button>
          </ng-container>
          <app-context *ngIf="isDesktop"></app-context>
          <li>
            <app-svg-icon [icon]="'search'" (click)="searchToggle()"></app-svg-icon>
          </li>
          <li class="onhover-dropdown">
            <app-notification></app-notification>
          </li>
          <li>
            <!--   <div class="mode" (click)="layoutToggle()">
              <app-svg-icon [icon]="'moon'"></app-svg-icon>
            </div> -->
            <app-mode></app-mode>
          </li>

          <li class="onhover-dropdown">
            <div class="notification-box">
              <i class="fa fa-question-circle fa-lg"></i>
            </div>
            <div class="onhover-show-div notification-dropdown">
              <ul>
                <li>
                  <h6 class="f-18 mb-0 dropdown-title">{{ "PROPERTIES.Pomoć" | translate}}</h6>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="novaFaktura()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.Kako napraviti novu fakturu" | translate}}
                  </a>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="unosRobe()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.Kako unijeti robu u fi-we" | translate}}
                  </a>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="unijetiTrosak()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.Kako unijeti trošak u sistem" | translate}}
                  </a>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="trajniIzvjetaj()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.Kako napraviti trajni izvještaj brzo" | translate}}
                  </a>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="financijskiNalog()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.Kako unijeti financijski nalog" | translate}}
                  </a>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="dmsBrziUnosDokuementa()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.DMS brzi unos dokumenta" | translate}}
                  </a>
                </li>

                <li>
                  <a class="dropdown-item pl-2 py-2" (click)="uvodUKoristenje()">
                    <i class="fa fa-video-camera fa-fw me-1 ms-1"></i>
                    {{"PROPERTIES.Uvod u korištenje programa FI-WE" | translate}}
                  </a>
                </li>

              </ul>
            </div>
          </li>

          <li class="language-nav" (click)="languageToggle()">
            <app-languages></app-languages>
          </li>

          <li class="onhover-dropdown height-38 mb-1">
            <app-user-dropdown></app-user-dropdown>
          </li>

          @if (!isDesktop) {
          <li class="onhover-dropdown">
            <div>
              <i class="fa fa-building"></i>
            </div>
            <div class="onhover-show-div active">
              <app-context></app-context>
            </div>
          </li>
          <li>
            <h6 class="mt-2"> {{ (accountService?.contextFirmData?.nFirma.length > 25)?
              (accountService?.contextFirmData?.nFirma | slice:0:25)+'...':(accountService?.contextFirmData?.nFirma) }}
            </h6>
          </li>
          }

        </ul>
      </div>
    </div>
  </div>
  <!-- Page Header Ends -->
</div>